import React from 'react';
import { METRIKA_GOALS, reachGoal } from '../analytics';

function School() {
  return (
    <section id="school" className="section school-section">
      <div className="section-heading">
        <p className="eyebrow">02 / Школа управления</p>
        <h2>3 уровня подготовки руководителя — от открытых лекций до персональной программы развития лидера</h2>
      </div>

      <div className="ladder">
        <article className="level">
          <div className="level-marker">
            <span>Уровень 01</span>
          </div>
          <div className="level-body">
            <h3>Руководитель</h3>
            <p className="level-tag">открытые лекции — бесплатно</p>
            <p>
              Управленческие инструменты и разборы в открытом доступе. Лучший
              способ познакомиться с подходом до того, как идти глубже.
            </p>
            <div className="level-links" aria-label="Каналы с лекциями">
              <a
                href="https://school.glotov.pro/diagnostika"
                target="_blank"
                rel="noopener noreferrer"
                data-metrika-goal={METRIKA_GOALS.SELECT_SCHOOL}
                onClick={() => reachGoal(METRIKA_GOALS.SELECT_SCHOOL)}
              >
                Диагностика — 8–10 минут
              </a>
              <a
                href="https://t.me/glotov_pro/63"
                target="_blank"
                rel="noopener noreferrer"
                data-metrika-goal={METRIKA_GOALS.SELECT_SCHOOL}
                onClick={() => reachGoal(METRIKA_GOALS.SELECT_SCHOOL)}
              >
                Telegram
              </a>
              <a
                href="https://www.youtube.com/watch?v=Q6uCZyEmG_Y&list=PLVR7xhlo3l2Qu4LclVaXmB3wkhZkJUR0g"
                target="_blank"
                rel="noopener noreferrer"
                data-metrika-goal={METRIKA_GOALS.SELECT_SCHOOL}
                onClick={() => reachGoal(METRIKA_GOALS.SELECT_SCHOOL)}
              >
                YouTube
              </a>
              <a
                href="https://rutube.ru/channel/44426477/videos/"
                target="_blank"
                rel="noopener noreferrer"
                data-metrika-goal={METRIKA_GOALS.SELECT_SCHOOL}
                onClick={() => reachGoal(METRIKA_GOALS.SELECT_SCHOOL)}
              >
                RuTube
              </a>
            </div>
          </div>
        </article>

        <article className="level">
          <div className="level-marker">
            <span>Уровень 02</span>
          </div>
          <div className="level-body">
            <h3>Архитектор реальности</h3>
            <p className="level-tag">основная программа развития руководителей</p>
            <p>
              Программа для руководителей и предпринимателей, которым нужна
              системность, практический язык решений и управленческая глубина.
            </p>
            <a
              className="button button-primary"
              href="https://school.glotov.pro/kurs"
              target="_blank"
              rel="noopener noreferrer"
              data-metrika-goal={METRIKA_GOALS.SELECT_SCHOOL}
              onClick={() => reachGoal(METRIKA_GOALS.SELECT_SCHOOL)}
            >
              Записаться на курс
            </a>
            <div className="level-links" aria-label="Пробное занятие">
              <a
                href="https://school.glotov.pro/miroopisanie"
                target="_blank"
                rel="noopener noreferrer"
                data-metrika-goal={METRIKA_GOALS.SELECT_SCHOOL}
                onClick={() => reachGoal(METRIKA_GOALS.SELECT_SCHOOL)}
              >
                Первое занятие курса — бесплатно
              </a>
            </div>
          </div>
          <div className="level-aside">
            <blockquote className="testimonial">
              <p>
                Особенно понравился баланс между простыми, но точными
                аналогиями из математики и глубоким пониманием человеческой
                мотивации. Как математик, отмечаю корректность и уместность
                технических образов, а как руководитель — ценю их практическую
                силу.
              </p>
              <footer>
                <strong>Максим</strong>
                <span>Team Lead Data Science</span>
              </footer>
            </blockquote>
            <blockquote className="testimonial">
              <p>
                Лекции — это не сухая теория, а живое, увлекательное и глубоко
                продуманное изложение с огромным количеством практических
                примеров. После программы у меня появилось чёткое понимание,
                как системно развивать бизнес и команду.
              </p>
              <footer>
                <strong>Инесса Пученкова</strong>
                <span>предприниматель, управляющий партнёр сети маркетов</span>
              </footer>
            </blockquote>
            <blockquote className="testimonial">
              <p>
                Грамотная структурная подача информации, разбор реальных
                бизнес-кейсов, систематизация имеющихся и вновь получаемых
                знаний. Всё это стоит потраченного времени.
              </p>
              <footer>
                <strong>Константин Камышный</strong>
                <span>системный предприниматель, траблшутер, PMP</span>
              </footer>
            </blockquote>
          </div>
        </article>

        <article className="level">
          <div className="level-marker">
            <span>Уровень 03</span>
          </div>
          <div className="level-body">
            <h3>Мета-Субъект</h3>
            <p className="level-tag">персональная программа развития лидера</p>
            <p>
              Индивидуальная работа один на один по программе, собранной под
              вашу ситуацию. В основе — психологическое образование и
              исследовательская работа по психологии управления. Программа
              включает три части:
            </p>
            <ul className="level-parts">
              <li>
                <span className="part-index" aria-hidden="true">I</span>
                <div>
                  <strong>Теория и методология управления</strong>
                  <p>
                    Расширенные управленческие знания — глубже и точнее под
                    вашу практику, чем даёт групповая программа.
                  </p>
                </div>
              </li>
              <li>
                <span className="part-index" aria-hidden="true">II</span>
                <div>
                  <strong>Консультирование по вашим задачам</strong>
                  <p>
                    Разбор реальных управленческих ситуаций и решений, с
                    которыми вы работаете прямо сейчас.
                  </p>
                </div>
              </li>
              <li>
                <span className="part-index" aria-hidden="true">III</span>
                <div>
                  <strong>Личностное развитие лидера</strong>
                  <p>
                    Авторская психологическая программа: мышление, ограничения,
                    цели и управленческая энергия.
                  </p>
                  <a href="/meta/">Схемы методики →</a>
                </div>
              </li>
            </ul>
            <div className="price-row" aria-label="Стоимость">
              <div className="price-item">
                <span className="price-value">3 000 ₽</span>
                <span className="price-note">
                  первая встреча, 40–60 минут: диагностика и формулировка
                  запроса
                </span>
              </div>
              <div className="price-item">
                <span className="price-value">10 000 ₽</span>
                <span className="price-note">
                  каждая следующая сессия по индивидуальной программе
                </span>
              </div>
            </div>
            <a
              className="button button-primary"
              href="https://school.glotov.pro/meta-vstrecha"
              target="_blank"
              rel="noopener noreferrer"
              data-metrika-goal={METRIKA_GOALS.SELECT_PERSONAL}
              onClick={() => reachGoal(METRIKA_GOALS.SELECT_PERSONAL)}
            >
              Записаться на первую встречу
            </a>
          </div>
          <div className="level-aside">
            <figure className="level-photo">
              <img src="/ana1816.webp" alt="Алексей Глотов" loading="lazy" />
            </figure>
            <blockquote className="testimonial">
              <p>
                Изначально реализовали с Алексеем два проекта по внедрению ИИ
                в нашей компании, и после этого заинтересовалась его авторской
                программой развития лидеров. Алексей очень аккуратно вышел на
                корневую проблему, которая мешала мне идти дальше — она
                оказалась в плоскости отношений с одним человеком. В
                результате за несколько сессий удалось решить вопрос,
                почувствовала, что теперь готова к свершениям!
              </p>
              <footer>
                <strong>Мария</strong>
                <span>генеральный директор, сеть кафе</span>
              </footer>
            </blockquote>
            <blockquote className="testimonial">
              <p>
                Столкнулся с кризисом целей: вроде бы всего добился, но
                хотелось чего-то большего. Алексей предложил пройти по
                программе самоактуализации — глубинные работы с подсознанием.
                К концу первого месяца начал осознавать, чем хочу заниматься
                дальше, а ещё через месяц был готов пошаговый план действий!
              </p>
              <footer>
                <strong>Антон</strong>
                <span>технический директор, промышленное предприятие</span>
              </footer>
            </blockquote>
          </div>
        </article>
      </div>
    </section>
  );
}

export default School;
